import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'help_center-open_quick_modal_event-click';
/**
 * Emits Action Type on click event for the quick action button
 */
export function trackHelpCenterOpenQuickModalEventClick(ACTION_TYPE) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { ACTION_TYPE },
    });
}
